import React, { useState } from "react";
import Searching from "./Searching";
import Details from "./Details";
const Products = () => {
  const [productId, setProductId] = useState(null);
  return (
    <div>
      {productId ? (
        <div>
          <Details currentId = {productId} setId={setProductId}/>
        </div>
      ) : (
        null
        )}
        <Searching product_id={productId} setId={setProductId} />
    </div>
  );
};
export default Products;
